import React, { FC } from 'react';

type Props = {
  fill?: string;
  stroke?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
};

const CheckSmallIcon: FC<Props> = ({
  fill = '#151514',
  stroke = '#151514',
  width = 12,
  height = 10,
  className
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966 4.02557L1 4.85653Z"
      fill={fill}
      stroke={stroke}
    />
  </svg>
);

export default CheckSmallIcon;
import React, { FC } from 'react';

type Props = {
  fill?: string;
  stroke?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
};

const CheckSmallIcon: FC<Props> = ({
  fill = '#151514',
  stroke = '#151514',
  width = 12,
  height = 10,
  className
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966 4.02557L1 4.85653Z"
      fill={fill}
      stroke={stroke}
    />
  </svg>
);

export default CheckSmallIcon;
